export default __webpack_public_path__ + "static/media/slide_5.3b94ea9b.jpg";